import { DroneModel } from './drone-model.enum';

export const droneModels: StringMap<string> = {
  [DroneModel.Parrot]: 'Parrot',
  [DroneModel.DJI]: 'DJI',
  [DroneModel.DJI_Pilot_2]: 'DJI Pilot 2',
  [DroneModel.OBS_STUDIO]: 'OBS Studio',
  [DroneModel.Other]: 'OTHER',
};
